import React from 'react';
import type { IconProps } from './IconPlus';

export const IconCart: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Shopping cart/marketplace icon */}
    <path d="M2 2H3.5L4.5 6M4.5 6L6 14H16L18 6H4.5Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="7" cy="17" r="1" fill={color}/>
    <circle cx="15" cy="17" r="1" fill={color}/>
  </svg>
);
